import { Typography } from '@material-ui/core'
import React from 'react'

export const getBatteryColor = (percentage) => {
  if (percentage >= 31) {
    return '#4fd975'
  } else if (percentage >= 11) {
    return '#ff9a43'
  } else {
    return '#f74872'
  }
}
export const BatteryIcon = ({ original }) => {
  const { batteryPercentage: percentage } = original
  const MAX_WIDTH = 20
  const availableBatteryWidth = MAX_WIDTH * (percentage / 100)
  const color = getBatteryColor(percentage)
  return (
    <>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="27"
        height="12"
        viewBox="0 0 27 12"
      >
        <g transform="translate(0 -.5)">
          <g
            fill="none"
            strokeMiterlimit="10"
            data-name="Battery Outline"
            opacity="0.47"
          >
            <path
              d="M0 2.609A2.556 2.556 0 012.5 0h19A2.556 2.556 0 0124 2.609v6.782A2.556 2.556 0 0121.5 12h-19A2.556 2.556 0 010 9.391z"
              transform="translate(0 .5)"
            ></path>
            <path
              fill={color}
              d="M2.5 1C1.673 1 1 1.722 1 2.609V9.39c0 .888.673 1.61 1.5 1.61h19c.827 0 1.5-.722 1.5-1.609V2.61C23 1.722 22.327 1 21.5 1h-19m0-1h19C22.88 0 24 1.168 24 2.609V9.39c0 1.442-1.12 2.61-2.5 2.61H0h2.5C1.12 12 0 10.832 0 9.391V2.61C0 1.168 1.12 0 2.5 0z"
              transform="translate(0 .5)"
            ></path>
          </g>
          <path
            fill={color}
            d="M0 0c1.165.291 2 1.076 2 2s-.835 1.709-2 2z"
            data-name="Battery Connector"
            opacity="0.58"
            transform="translate(25 4.5)"
          ></path>
          <rect
            width={availableBatteryWidth}
            height="8"
            fill={color}
            data-name="Battery Fill"
            rx="1"
            transform="translate(2 2.5)"
          ></rect>
        </g>
      </svg>
      <Typography
        className="ltr:ml-8 rtl:mr-8"
        style={{
          color: getBatteryColor(percentage),
        }}
      >
        {`${percentage}%`}
      </Typography>
    </>
  )
}
